import { apiFactory } from "generated";
import { Event } from "generated/models";
import { ResponseDto } from "types";
import {
    createErrorResponseStandard,
    createResponseStandard,
} from "utils/functions";
import AxiosInstance from "service/axiosInstance";
import { eventServiceQueryKeys } from "./eventQueryKeys";
import { serviceQueryClient } from "./queryClient";

const eventClient = apiFactory.getEventsInstance(AxiosInstance);

// Cache for 3 minutes
const eventOrganizationCachePolicy = {
    staleTime: 3 * 60 * 1000,
    cacheTime: 0,
    retry: 1 as number | boolean,
};

type EventOrganizationCacheOptions = Partial<
    typeof eventOrganizationCachePolicy
>;

const fetchEventsByOrganizationId = async (
    organizationId: string
): Promise<ResponseDto<Event[]>> => {
    try {
        const response = await eventClient.getEventsByOrganizationId({
            organization_id: organizationId,
        });
        return createResponseStandard<Event[]>(response);
    } catch (error) {
        return createErrorResponseStandard(error);
    }
};

export const getEventsByOrganizationIdCached = async (
    organizationId: string,
    options: EventOrganizationCacheOptions = {}
): Promise<ResponseDto<Event[]>> =>
    serviceQueryClient.fetchQuery({
        queryKey: eventServiceQueryKeys.eventsByOrganizationId(organizationId),
        queryFn: () => fetchEventsByOrganizationId(organizationId),
        staleTime:
            options.staleTime ?? eventOrganizationCachePolicy.staleTime,
        cacheTime:
            options.cacheTime ?? eventOrganizationCachePolicy.cacheTime,
        retry: options.retry ?? eventOrganizationCachePolicy.retry,
    });
